import Icon, { IconName } from '@/components/atomic/icon'
import { cn } from '@/utils/shadcn/utils'

interface ComplianceListContainerProps {
  children: React.ReactNode
  className?: string
}

export function ComplianceListContainer({
  children,
  className,
}: ComplianceListContainerProps) {
  return <div className={cn('flex flex-col', className)}>{children}</div>
}

interface TitleContainerProps {
  children: React.ReactNode
  hasError?: boolean
}

export function TitleContainer({ children, hasError }: TitleContainerProps) {
  return (
    <div className="flex items-center gap-2">
      {children}
      {hasError && (
        <Icon
          iconName={IconName.ExclamationTriangleIcon}
          className="h-4 w-4 text-moment-red-700"
        />
      )}
    </div>
  )
}

interface ItemsContainerProps {
  children: React.ReactNode
}

export function ItemsContainer({ children }: ItemsContainerProps) {
  return <div className="space-y-1">{children}</div>
}

export const ChartContainer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'h-[300px] w-full border border-primary-border rounded-[6px]',
      className,
    )}
    {...props}
  />
)

export const TooltipContainer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('bg-background p-3 shadow-md rounded-md', className)}
    {...props}
  />
)

export const TooltipLabel = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-sm font-medium mb-1', className)} {...props} />
)

export const TooltipItemContainer = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex items-center gap-2', className)} {...props} />
)

export const TooltipColorIndicator = ({
  className,
  style,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('w-3 h-3 rounded-full', className)}
    style={style}
    {...props}
  />
)

export const TooltipItemText = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) => (
  <p className={cn('text-sm text-gray-600', className)} {...props} />
)
